// src/auth/auth.ts
import { Constant } from '../config/constant';
export class Auth {
    constructor(credentials) {
        this.credentials = credentials;
        this.authData = {
            AccessToken: '',
            RefreshToken: '',
        };
    }
    static getInstance(credentials) {
        if (!Auth.instance) {
            if (!credentials) {
                throw Error("Forbidden");
            }
            Auth.instance = new Auth(credentials);
        }
        return Auth.instance;
    }
    async authenticate(forceAuth) {
        var _a, _b;
        if (!forceAuth && this.authData.AccessToken && !this.isTokenExpired(this.authData.AccessToken)) {
            return this.authData;
        }
        if (this.credentials.getCredentials) {
            const credentials = this.credentials.getCredentials();
            this.credentials.AccessToken = credentials.AccessToken;
            this.credentials.ClientID = credentials.ClientID;
            this.credentials.ClientSecret = credentials.ClientSecret;
            this.credentials.OrgTitle = credentials.OrgTitle;
            this.credentials.Environment = credentials.Environment;
            this.credentials.ProjectKey = credentials.ProjectKey;
        }
        const { AccessToken, ClientID, ClientSecret, OrgTitle, Environment, ProjectKey } = this.credentials;
        if (!OrgTitle || !Environment || !ProjectKey) {
            throw new Error("OrgTitle, Environment, and ProjectKey are required for authentication.");
        }
        if (!AccessToken) {
            if (!ClientID || !ClientSecret) {
                throw new Error("ClientID and ClientSecret are required when AccessToken is not present.");
            }
        }
        const headerPayload = {
            'Client-Id': this.credentials.ClientID,
            'Client-Secret': this.credentials.ClientSecret,
            'X-Org': this.credentials.OrgTitle,
            'Environment': this.credentials.Environment,
            'ProjectKey': this.credentials.ProjectKey,
        };
        if (this.credentials.AccessToken) {
            headerPayload['T-pass'] = this.credentials.AccessToken;
        }
        if ((_a = this.credentials.config) === null || _a === void 0 ? void 0 : _a.AuthToken) {
            headerPayload['X-pass'] = (_b = this.credentials.config) === null || _b === void 0 ? void 0 : _b.AuthToken;
        }
        const response = await fetch(`${Constant.BASE_URL}/auth/token`, {
            method: 'POST',
            headers: headerPayload,
        });
        if (!response.ok) {
            const errorBody = await response.json().catch(() => null);
            const errorMessage = (errorBody === null || errorBody === void 0 ? void 0 : errorBody.message) || `HTTP ${response.status} ${response.statusText}`;
            throw new Error(errorMessage);
        }
        const { data } = await response.json();
        this.authData = {
            AccessToken: data.access_token,
            RefreshToken: data.refresh_token,
        };
        return this.authData;
    }
    getAuthData() {
        return this.authData;
    }
    getCredentials() {
        return this.credentials;
    }
    decodeJwtPayload(token) {
        const [, payloadB64 = ""] = token.split('.');
        // Base64-URL → Base64
        const b64 = payloadB64.replace(/-/g, '+').replace(/_/g, '/')
            // pad to multiple of 4
            .padEnd(payloadB64.length + (4 - payloadB64.length % 4) % 4, '=');
        let json;
        if (typeof window !== 'undefined' && typeof window.atob === 'function') {
            // browser
            json = atob(b64);
        }
        else {
            // Node.js
            json = Buffer.from(b64, 'base64').toString('utf8');
        }
        return JSON.parse(json);
    }
    isTokenExpired(token) {
        try {
            const { exp } = this.decodeJwtPayload(token);
            return typeof exp === 'number'
                ? exp < Math.floor(Date.now() / 1000) - 100
                : true;
        }
        catch (_a) {
            return true;
        }
    }
}
